import script from "./Header.vue?vue&type=script&lang=ts&setup=true"
export * from "./Header.vue?vue&type=script&lang=ts&setup=true"

import "./Header.vue?vue&type=style&index=0&id=5cf9eec9&lang=less"

const __exports__ = script;

export default __exports__